import React from "react";

/**
 * <ModuleAccent module="..."> wrapper
 *
 * Applica la firma cromatica del modulo:
 *   - data-module="..." sul wrapper (override CSS variables --mod-accent*)
 *   - sottile linea accent in alto (eco-mod-accent-line)
 *   - radial glow opzionale di sfondo (eco-mod-backdrop)
 *
 * Moduli supportati:
 *   "hub" | "workspace" | "aria"   → blu globale
 *   "totalpl"                       → magenta
 *   "ads"                           → viola
 *   "design"                        → cyan
 *   "offerteincitta"                → ambra
 *   "ellymenu"                      → rosso food
 *   "gostreet"                      → verde
 *   "photovendo"                    → viola chiaro
 *   "superadmin"                    → blu oversight
 *
 * Props:
 *   module     string (vedi sopra). Default "hub".
 *   backdrop   bool. Default true → mostra glow radiale di sfondo.
 *   line       bool. Default true → mostra linea accent in cima.
 *   as         tag. Default "div".
 *   className  string extra.
 *
 * Uso:
 *   <ModuleAccent module="totalpl">
 *      <YourPage />
 *   </ModuleAccent>
 */
export default function ModuleAccent({
    module = "hub",
    backdrop = true,
    line = true,
    as: Tag = "div",
    className = "",
    children,
    style,
    ...rest
}) {
    return (
        <Tag
            data-module={module}
            data-testid={`module-accent-${module}`}
            className={`${backdrop ? "eco-mod-backdrop" : ""} ${className}`.trim()}
            style={style}
            {...rest}
        >
            {line && <span className="eco-mod-accent-line" aria-hidden />}
            {children}
        </Tag>
    );
}
